import React, { Component } from 'react'
import img1 from '../../static/images/payment-banner.png'
import product3 from '../../static/images/product-3.png'

import advantage2 from '../../static/images/about-1.png'
import about2 from '../../static/images/about-2.png'
import about3 from '../../static/images/about-3.png'
import about4 from '../../static/images/about-4.png'


import './index.less';
class aboutUs extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
      componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'component-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                 <iframe 
                 title="component-static"
                 src={`${process.env.PUBLIC_URL}/static/antComponent/antComponent.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container unattended-container affiliate-container payment-container unmanner-reatail-container about-us-page">
            //     <div className="top-home-carousel">                                

            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-tips red-color">愿景</div>
            //                     <div className="banner-top-tips">成为全球领先的零售赋能平台 </div>
            //                     <div className="banner-top-tips red-color">价值观联合</div>
            //                     <div className="banner-top-tips">/拓展/跨界/共赢理想/行动/坚持/卓越  </div>
            //                     <div className="banner-top-tips red-color">使命</div>
            //                     <div className="banner-top-tips">让零售更高效，让生活更美好 </div>
            //                 </div>

            //             </div>

            //         </div>
            //     </div>


            //     <div className="common-block-home">
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">悦喵Ai从何而来？</div>
            //                     <div className="advantage-detail-left-tips">悦喵Ai致力于通过提供智能在线值守技术、系统、设备、及云端值守等综合解决方案，为传统便利店、社区超市等多种零售业态全面赋能，在不改变原有经营模式下，让零售门店完成数字化、智能化升级改造，实现高峰期现场值守，低峰期云值守，全天候24h不间断营业，彻底解决零售业守店之痛。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">悦喵Ai在做什么？</div>
            //                     <div className="advantage-detail-left-tips">悦喵Ai致力于通过提供智能在线值守技术、系统、设备、及云端值守等综合解决方案，为传统便利店、社区超市等多种零售业态全面赋能，在不改变原有经营模式下，让零售门店完成数字化、智能化升级改造，实现高峰期现场值守，低峰期云值守，全天候24h不间断营业，彻底解决零售业守店之痛</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">悦喵Ai往何处去？</div>
            //                     <div className="advantage-detail-left-tips">坚守门店“数智化”核心理念，以“24小时不打烊”、

            //                         “智能云值守服务”为切入点，

            //                         为千万社区超市、便利店赋能，让更多线下零售店能够享受智能化和品牌连锁化带来的高收益和高回报。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>

            //         </div>
                    
            //     </div>
            //     <div className="common-block-home advantage-common-block-home">
            //         <div className="title-style-about">团队创始人</div>
            //     </div>
            //     <div className="common-block-home">
            //         <div className="founder-content">
            //             <img className="founder-img" src={about2} alt="" />
            //             <div className="founder-content-right">
            //                 <div className="founder-title">陈鹏&董事长&CEO</div>
            //                 <div className="founder-tips">*激情务实的连续创业者,2007年创建联拓天际，15年平台交易超过250亿，成为国内优质的机票航旅分销平台并获上市公司4.38亿的战略投资</div>
            //                 <div className="founder-tips">*2013年10月创建联拓数科，并获得国内顶尖VC联想之星，光信资本，汇付天下等共同投资上亿元，成为国内领先的新零售科技公司</div>
            //                 <div className="founder-tips">*2020年底创建悦喵Ai同时出任董事长兼CEO</div>
            //             </div>
            //         </div>
            //         <div className="founder-content">
            //             <img className="founder-img" src={about3} alt="" />
            //             <div className="founder-content-right">
            //                 <div className="founder-title">刘靖峰&首席科学家</div>
            //                 <div className="founder-tips">*2016年创立神目科技，研发出全球领先的人工智能物联网操作系统</div>
            //                 <div className="founder-tips">*拥有40多项国际专利，广泛布局智慧零售，智慧社区，食品安全等行业领域。</div>
            //                 <div className="founder-tips">*中组部千人计划专家，卡耐基梅隆大学电子与计算机工程博士，新加坡国立大学硕士，浙江大学学士</div>
            //             </div>
            //         </div>
            //     </div>

            //     <div className="top-home-carousel about-top">

            //         <div className="banner-bg"><img className="banner-img" src={about4} alt="" /></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     {/* <div className="banner-top-title">加入我们</div> */}
            //                     {/* <div className="banner-top-btn">查看招聘职位</div> */}
            //                 </div>

            //             </div>

            //         </div>
            //     </div>

            //     <div className="common-block-home unattended-first">
            //         <div className="common-block-home-title common-block-home-title-1">发展历程</div>
            //         <div className="common-block-product">
                       
            //             {/* <div className="store-model">
                           

            //             </div>
            //             <div className="store-model">


            //             </div>
            //             <div className="store-model">
                            
            //             </div> */}
            //         </div>
            //     </div>




            // </div >
        )
    }
}


export default aboutUs